module.exports = __webpack_public_path__ + "static/media/profile_photo.974cbaeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/profile_photo.jpg
// module id = 99
// module chunks = 0